
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'Modal',
    props: {
        visible: {
            type: Boolean,
            required: true,
        }
    },
    emits: ['update:visible'],
    methods: {
        close() {
            this.$emit('update:visible', false)
        },
    },
})
